import React from 'react';

const Error = ({ text }) => {
	return <span className='error'>{text}</span>;
};

Error.propTypes = {};

export default Error;
